import React, { useState } from 'react';
import { Frame, Divider, SageClassnames, Button, Badge } from '@kajabi/sage-react';
import { useTranslation } from 'react-i18next';
import CheckoutCartItems from '../CheckoutCartItems';
import { Cart } from '../types';
import { localizedPriceFromMinorUnit } from '../../popup_checkout/util';

const CartSummaryDropdown = ({ cart }: { cart: Cart }) => {
  const { t } = useTranslation();
  const [showSummary, setShowSummary] = useState(false);
  const { totalPrice } = cart;

  const localizedTotalPrice = totalPrice
    ? localizedPriceFromMinorUnit(totalPrice.currency, totalPrice.amount, totalPrice.exponent)
    : null;

  return (
    <>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        gap={Frame.GAPS.SM}
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        className="checkout-cart-accordion"
      >
        <Button
          small
          subtle
          icon={showSummary ? 'caret-up' : 'caret-down'}
          onClick={() => setShowSummary(!showSummary)}
          className={`${SageClassnames.TYPE.BODY_SMALL} ${SageClassnames.TYPE.BODY_SEMI}`}
        >
          {showSummary ? 'Hide' : 'Show'} order summary
        </Button>
        {!showSummary && (
          <span
            data-testid="order-total"
            className={`${SageClassnames.TYPE.HEADING_6} price-detail`}
            aria-labelledby="order-total"
          >
            <Badge
              className={`${SageClassnames.SPACERS.XS_RIGHT}`}
              value={cart.totalPrice?.currency}
            />
            {localizedTotalPrice}
          </span>
        )}
      </Frame>
      {!showSummary && <Divider />}
      {showSummary && (
        <div className="checkout-cart-accordion-content">
          <Divider />
          <div className="checkout-cart-accordion-items">
            <CheckoutCartItems cartItems={cart.items} />
            <Frame
              direction={Frame.DIRECTIONS.HORIZONTAL}
              gap={Frame.GAPS.XS}
              align={Frame.ALIGNMENTS.CENTER_SPREAD}
              width={Frame.WIDTHS.FILL}
              className={SageClassnames.SPACERS.SM_TOP}
            >
              <h5
                id="mobile-order-total"
                className={`order-total ${SageClassnames.TYPE.HEADING_5}`}
              >
                {t('messages.cart.order_total')}
              </h5>
              <h5
                data-testid="order-total"
                className={`${SageClassnames.TYPE.HEADING_6}`}
                aria-labelledby="order-total"
              >
                <Badge
                  className={`${SageClassnames.SPACERS.XS_RIGHT}`}
                  value={cart.totalPrice?.currency}
                />
                {localizedTotalPrice}
              </h5>
            </Frame>
          </div>
        </div>
      )}
    </>
  );
};

export default CartSummaryDropdown;
